import { useEffect, useRef } from 'react';
import { startSession } from './client';
import { startEventStream } from './eventStream';

// Once per page load, once signed in: tells designs-backend the Kinde token
// is good and has it store the person's profile, so what they create
// carries their name, then opens the live event stream. Nothing waits on it; the
// outcome is only logged for now.
export const useBackendSession = (isSignedIn: boolean) => {
  // StrictMode runs effects twice in dev; the ref keeps it to one request.
  const started = useRef(false);

  useEffect(() => {
    if (!isSignedIn || started.current) return;
    started.current = true;
    startSession()
      .then((user) => {
        console.info('designs-backend session started for', user.id);
        startEventStream();
      })
      .catch((error: unknown) => {
        console.error('designs-backend session check failed', error);
      });
  }, [isSignedIn]);
};
